import { render } from "./Home.vue?vue&type=template&id=21fdae9e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Programs\\Herd\\posLaravel12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__